import { put, takeLatest, takeEvery } from "@redux-saga/core/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertTrySelect,
  handleNotificationAlertCatch,
  handleNotificationAlertTryUpdate,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectLottery: "[selectLottery] Action",
  selectLotteryLoad: "[selectLotteryLoad] Action",
  selectLotteryAsync: "[selectLotteryAsync] Action",
};

const initialState = {
  data: [],
  loading: false,
};

export const select_lottery_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectLottery:
      return {
        ...state,
        data: payload?.data?.results ? payload?.data?.results : [],
      };

    case actionTypes.selectLotteryLoad:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
    yield put({ type: actionTypes.selectLotteryLoad, payload: true });
    let config = {
        url: "select_request",
    };
    
    let data = {
        table: "lottery",
        method_type: "select_lottery",
        data: {},
        sort_by: {},
        size: "50",
        from: "0",
    };
    

    try {
    let res = yield AxiosCustom(config, data);


    yield put({
      type: actionTypes.selectLottery,
      payload: res.data.response,
    });
  } catch {
    handleNotificationAlertCatch();
    // yield put({ type: actionTypes.creaditSelectLoad, payload: false });
  } finally {
    yield put({ type: actionTypes.selectLotteryLoad, payload: false });
  }
}

export function* selectLottery() {
  yield takeEvery(actionTypes.selectLotteryAsync, handleWorker);
}
